module.exports = __webpack_public_path__ + "img/Laptop-01.2ae0f2f5.svg";